import { render, staticRenderFns } from "./AddPageComponent.vue?vue&type=template&id=6b4ae2c8&"
import script from "./AddPageComponent.vue?vue&type=script&lang=js&"
export * from "./AddPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports